import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AppConfiguration } from '../../services/configuration/app.configuration';
import { resolveTestCountry } from '../../services/test-country/test-country';

/**
 * QA-only плашка: показывает активную эмуляцию страны (`?test_country=BR`) на stage/dev.
 * Не рендерится в production и когда эмуляция выключена. Текст не переводится.
 */
@Component({
  selector: 'app-test-country-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (country) {
      <div
        class="pointer-events-none fixed bottom-2 left-2 z-[10000001] rounded bg-black/80 px-2 py-1 text-xs font-medium text-white"
        aria-hidden="true"
        data-testid="app-qa.status.test-country">
        Test country: {{ country }}
      </div>
    }
  `,
})
export class TestCountryBadgeComponent {
  // Читается один раз при старте: смена URL без перезагрузки плашку не обновляет
  protected readonly country = resolveTestCountry(inject(AppConfiguration).production);
}
